import ACCOUNT_CLIENT_API_ENDPOINTS from '@api/endpoints';
import HTTP_METHODS_ENUM from '@api/enums/HTTP_METHODS_ENUM.enum';
import configRequest from '@api/requests/configRequest';

export interface GetMFAMethodsResponse {
	options: string[];
}

const getMFAMethods = configRequest<GetMFAMethodsResponse, void>({
	requestPrefix: 'mfa/getMFAMethods',
	reqConfigCreator: () => ({
		url: ACCOUNT_CLIENT_API_ENDPOINTS.MFA.GET_MFA_METHODS(),
		method: HTTP_METHODS_ENUM.GET,
	}),
});

export default getMFAMethods;
